module.exports = __webpack_public_path__ + "static/media/b3_p10_clickable_b.569cd004.mp3";